const InvestorRegistrationStatusEnum = Object.freeze({
    REGISTERING: 'REGISTERING',
    ONBOARDING: 'ONBOARDING',
    APPLYING: 'APPLYING',
    COMPLETE: 'COMPLETE'
});

export default InvestorRegistrationStatusEnum;
